import React from "react";
import "antd/dist/antd.css";
import "./TableComp.module.css";
import { Row, Col } from "antd";
import Iframe from "react-iframe";

const TableComp = () => {
  return (
    <Row style={{ margin: "10px", padding: "10px" }}>
      {/* <Col className="gutter-row" span={2}></Col> */}
      <Col className="gutter-row" span={22}>
        <Iframe
          url="http://cci.netskope.io/appIndex/index.php/"
          width="1650px"
          height="550px"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
        />
        <Iframe
          url="http://cci.netskope.io:8000/webcategory/report"
          width="1650px"
          height="550px"
          id="myId"
          className="myClassname"
          display="initial"
          position="relative"
        />
      </Col>
    </Row>
  );
};

export default TableComp;

{
  /* <iframe
id="inlineFrameExample"
title="Inline Frame Example"
width="1650"
height="400"
src="http://cci.netskope.io/appIndex/index.php/"
></iframe>

<iframe
id="inlineFrameExample"
title="Inline Frame Example"
width="1650"
height="400"
src="http://172.16.96.172:8000/webcategory/report"
></iframe> */
}
